import styled, { createGlobalStyle } from "styled-components";

const isMaxWidthDdcPage = false;

export const StyledTableWrapper = styled.div`
  .ant-table-sticky-scroll,
  .ids-row-select-header-cell {
    display: none;
  }
  .ant-table-tbody > tr.ant-table-expanded-row {
    & > td.ant-table-cell div.ant-table-expanded-row-fixed {
      padding: 0 !important;
      padding-left: 8px !important;
    }
    border-bottom: 1px solid #d3d3d3;
  }
  & :is(.ant-table-thead, .ant-table-tbody) {
    & tr :is(th, td) {
      --cell-width: 150px;
      --cell-height: 30px;
      min-width: var(--cell-width);
      width: var(--cell-width);
      height: var(--cell-height);
      min-height: var(--cell-height);
      max-height: var(--cell-height);
      overflow: hidden;
      border: 1px solid #d3d3d3;
      text-wrap: nowrap;
      &:is(.column-actual_cash_value) {
        --cell-width: 160px;
      }
      &:is(
          .column-autonation_pkg_disc,
          .column-autonation_msrp_adv,
          .column-image_date_time_zone,
          .column-warranty_description,
          .column-autonation_accessories
        ) {
        --cell-width: 180px;
      }
      &:is(
          .column-autonation_customer_cash,
          .column-elead_price_less_oem_cash
        ) {
        --cell-width: 210px;
      }
      &:is(
          .column-autonation_msrp_before_pkg_disc,
          .column-external_images_last_modified_date
        ) {
        --cell-width: 260px;
      }
    }
  }
`;

export const TableStyles = createGlobalStyle`
  ${isMaxWidthDdcPage && '[data-testid="ddc-page"] { max-width: 100%; }'}
  .ant-table > .ant-table-container {
    ${
      isMaxWidthDdcPage
        ? "max-width: calc(100vw);"
        : "max-width: min(98vw, 1475px);"
    }
  }
`;
